import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AuthActions, AuthService, IAuthAction } from "ionic-appauth";
import { Observable } from "rxjs";
import { GetContentsRequest } from "../models/getContentsRequest";
import { RequestType } from "./http-interceptor.service";

@Injectable({
    providedIn: 'root'
})
export class ContentService {

    constructor(
        private authService: AuthService,
        private httpClient: HttpClient
    ) { }

    /* Desde acá hay que sacarlo del servicio de profile y pasarlo a un nuevo "content.service"*/
    public getContainer( code ){
        const opt = {
            code,
            parentId: ""
        }
        return this.httpClient.post(`${RequestType.API}/container`, opt )
    }

    public getContainerByName( name ){
        const opt = {
            name
        }
        return this.httpClient.post(`${RequestType.API}/containerByName`, opt )
    }

    public getPath( code ){
        const opt = {
            code
        }
        return this.httpClient.post(`${RequestType.API}/getPath`, opt )
    }

    public getPathName( name ){
        const opt = {
            name
        }
        return this.httpClient.post(`${RequestType.API}/getPathName`, opt )
    }

    public getContents( params: GetContentsRequest ){
        return this.httpClient.post(`${RequestType.API}/getContents`, params )
    }

    public getContentsTypes( ){
        return this.httpClient.post(`${RequestType.API}/typeContents`, {} )
    }

    public getContent( contentId, profileId ){
        const opt = {
            contentId,
            profileId 
          }
        return this.httpClient.post(`${RequestType.API}/content`, opt )
    }

    public addFavorite( opt ) {
        return this.httpClient.post(`${RequestType.API}/addFavorite`, opt )
    }
    public removeFavorite( opt ) {
        return this.httpClient.post(`${RequestType.API}/removeFavorite`, opt )
    }
    public getFavorites( opt ) {
        return this.httpClient.post(`${RequestType.API}/favorites`, opt )
    }

    public subscribe( opt ) {
        return this.httpClient.post(`${RequestType.API}/subscribe`, opt )
    }
    public unSubscribe( opt ) {
        return this.httpClient.post(`${RequestType.API}/unSubscribe`, opt )
    }
    public getSubscribe( opt ) {
        return this.httpClient.post(`${RequestType.API}/profileSubscription`, opt )
    }

    public interest( opt ) {
        return this.httpClient.post(`${RequestType.API}/addInterest`, opt )
    }

    public confirm( opt ) {
        return this.httpClient.post(`${RequestType.API}/confirmSubscription`, opt )
    }

    public search( text: string ){
        const opt = {
            text
          }
        return this.httpClient.post(`${RequestType.API}/search`, opt )
    }

    public searchLikePlace( text: string ){
        const opt = {
            text
          }
        return this.httpClient.post(`${RequestType.API}/searchLikePlace`, opt )
    }
    
    public getPlaceTag(){
        
        return this.httpClient.post(`${RequestType.API}/placeTag`, {} )
    }

    public getPlace( placeId ){
        const opt = {
            placeId 
          }
        return this.httpClient.post(`${RequestType.API}/place`, opt )
    }

    public getPlaceType( tagId ){
        const opt = {
            tagId 
          }
        return this.httpClient.post(`${RequestType.API}/placeType`, opt )
    
    
    }

    public getTag( tagId ){
        const opt = {
            tagId 
          }
        return this.httpClient.post(`${RequestType.API}/infoTag`, opt )
    
    
    }

    public searchPlace( tagId, placeTypeId ){
        const opt = {
            placeTypeId,
            tagId
          }
        return this.httpClient.post(`${RequestType.API}/searchPlace`, opt )
    }

    public getStates() {
        return this.httpClient.post(`${RequestType.API}/state`, {} )
    }

    public getDepartment( stateId ){
        const opt = {
            stateId
          }
        return this.httpClient.post(`${RequestType.API}/departament`, opt )
    }

    public setProfileBenefit( benefitId, profileId, placeId ){
        const opt = {
            benefitId,
            profileId,
            placeId 
          }
        return this.httpClient.post(`${RequestType.API}/setProfileBenefit`, opt )
    }

    public getBenefit(benefitId) {
        const opt = {
            benefitId
          }
        return this.httpClient.post(`${RequestType.API}/infoBenefit`, opt )
    }

    public shareContent(profileId, contentId) {
        const opt = {
            profileId,
            contentId
          }
        return this.httpClient.post(`${RequestType.API}/shareContent`, opt )
    }

    normalizeString( string: string ) {
        const newString = string.replaceAll('á', 'a')
                                .replaceAll('à', 'a')
                                .replaceAll('ä', 'a')
                                .replaceAll('â', 'a')
                                .replaceAll('é', 'e')
                                .replaceAll('è', 'e')
                                .replaceAll('ë', 'e')
                                .replaceAll('ê', 'e')
                                .replaceAll('í', 'i')
                                .replaceAll('ì', 'i')
                                .replaceAll('ï', 'i')
                                .replaceAll('î', 'i')
                                .replaceAll('ó', 'o')
                                .replaceAll('ò', 'o')
                                .replaceAll('ö', 'o')
                                .replaceAll('ô', 'o')
                                .replaceAll('ú', 'u')
                                .replaceAll('ù', 'u')
                                .replaceAll('ü', 'u')
                                .replaceAll('ü', 'u')
                                .replaceAll('û', 'u')
                                .replaceAll('%20', '-')
                                .replaceAll(' ', '-')
                                .replaceAll(',', '')
                                .replaceAll('.', '')
                                .replaceAll(';', '')
        
        console.log( newString )
        return newString;
      }
}